import React from 'react'

import PropTypes from 'prop-types'

import './component4cards.css'

const Component4cards = (props) => {
  return (
    <div className={`component4cards-container1 ${props.rootClassName} `}>
      <div className="component4cards-container2">
        <h2 className="component4cards-thq-heading1-elm H1_medium">
          {props.heading1}
        </h2>
        <div className="component4cards-container3">
          <div className="component4cards-thq-column-elm1 thq-flex-column">
            {props.showImage === false && (
              <img
                alt={props.imageAlt}
                src={props.imageSrc}
                loading="lazy"
                className="component4cards-image1"
              />
            )}
            <div className="component4cards-thq-content-elm1 thq-flex-column">
              <h3 className="component4cards-thq-title1-elm">{props.title1}</h3>
              <span className="component4cards-thq-description1-elm1 text_medium">
                {props.description1}
              </span>
            </div>
          </div>
          <div className="component4cards-thq-column-elm2 thq-flex-column">
            {props.showImage1 === false && (
              <img
                alt={props.imageAlt1}
                src={props.imageSrc1}
                loading="lazy"
                className="component4cards-image2"
              />
            )}
            <div className="component4cards-thq-content-elm2 thq-flex-column">
              <strong className="component4cards-thq-title2-elm">
                {props.title2}
              </strong>
              <span className="component4cards-thq-description2-elm text_medium">
                {props.description2}
              </span>
            </div>
          </div>
          <div className="component4cards-thq-column-elm3 thq-flex-column">
            {props.showImage2 === false && (
              <img
                alt={props.imageAlt2}
                src={props.imageSrc2}
                loading="lazy"
                className="component4cards-image3"
              />
            )}
            <div className="component4cards-thq-content-elm3 thq-flex-column">
              <strong className="component4cards-thq-title3-elm">
                {props.title3}
              </strong>
              <span className="component4cards-thq-description3-elm">
                {props.description3}
              </span>
            </div>
          </div>
          <div className="component4cards-thq-column-elm4 thq-flex-column">
            {props.showImage3 === false && (
              <img
                alt={props.imageAlt3}
                src={props.imageSrc3}
                loading="lazy"
                className="component4cards-image4"
              />
            )}
            <div className="component4cards-thq-content-elm4 thq-flex-column">
              <h3 className="component4cards-thq-title4-elm">{props.title4}</h3>
              <span className="component4cards-thq-description1-elm2">
                {props.description4}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

Component4cards.defaultProps = {
  title4: 'Контроль оборудования',
  title3: 'Контроль затрат',
  showImage1: false,
  title2: 'Контроль качества',
  description3:
    'Видно, сколько реально расходуется газа, проволоки, электроэнергии и рабочего времени.',
  imageSrc: '',
  showImage2: false,
  description4:
    'Программа заранее предупредит о необходимости обслуживания оборудования.',
  description1:
    'Следите за всеми сварочными постами и роботами в режиме реального времени.',
  imageSrc1: '',
  imageSrc2: '',
  showImage3: false,
  rootClassName: '',
  description2:
    'Каждый сварной шов сохраняется вместе со всеми технологическими параметрами.',
  title1: 'Контроль производства',
  heading1: 'Что получает предприятие?',
  imageSrc3: '',
  showImage: false,
  imageAlt: '',
  imageAlt1: '',
  imageAlt2: '',
  imageAlt3: '',
}

Component4cards.propTypes = {
  title4: PropTypes.string,
  title3: PropTypes.string,
  showImage1: PropTypes.bool,
  title2: PropTypes.string,
  description3: PropTypes.string,
  imageSrc: PropTypes.string,
  showImage2: PropTypes.bool,
  description4: PropTypes.string,
  description1: PropTypes.string,
  imageSrc1: PropTypes.string,
  imageSrc2: PropTypes.string,
  showImage3: PropTypes.bool,
  rootClassName: PropTypes.string,
  description2: PropTypes.string,
  title1: PropTypes.string,
  heading1: PropTypes.string,
  imageSrc3: PropTypes.string,
  imageAlt: PropTypes.string,
  imageAlt1: PropTypes.string,
  imageAlt2: PropTypes.string,
  imageAlt3: PropTypes.string,
  showImage: PropTypes.bool,
}

export default Component4cards
